<div class="card filter-panel">
  <div class="card-body">
    <div class="title">{{ title }}</div>
    <div class="mt-2">
      <ul>
        @for (link of links; track link.url) {
          <li>
            <a [href]="link.url" class="link-item">{{ link.label }}</a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
